/** Pins the picked suggestion's point to the form fields it just filled; `null` when it has none. */
export function pinSuggestionPoint(meta, fields) {
    if (meta?.latitude == null || meta?.longitude == null)
        return null;
    return { point: { latitude: meta.latitude, longitude: meta.longitude }, fields: pickLocating(fields) };
}
/**
 * The point to send with the address, or `undefined` once any locating field moved away from the
 * pick. CONSTRAINT: OPHUB stores whatever point it is sent, so `LocatingFields` must list every
 * field that moves the address: one left out lets a stale point through after that field changes.
 */
export function pointForFields(pinned, fields) {
    if (!pinned)
        return undefined;
    const current = pickLocating(fields);
    const unchanged = Object.keys(pinned.fields).every((key) => normalise(pinned.fields[key]) === normalise(current[key]));
    return unchanged ? pinned.point : undefined;
}
function pickLocating(fields) {
    return {
        line1: fields.line1,
        streetName: fields.streetName,
        houseNumber: fields.houseNumber,
        houseNumberSuffix: fields.houseNumberSuffix,
        postalCode: fields.postalCode,
        city: fields.city,
        country: fields.country,
    };
}
function normalise(value) {
    return (value ?? "").trim().toLowerCase();
}
